export const Email = {
  sendContact: async(formData = null) => {
    try {
      return new Promise((resolve, reject) => {
        let methodType = 'POST';
        let headers = {
          'Accept': 'application/json',
          'content-type': 'application/json',
        };
        let body = null;
        if (formData) {
          body = JSON.stringify(formData);
        }
        window
          .fetch(`https://srjy0azi23.execute-api.us-east-1.amazonaws.com/dev/sendEmail`, {
              body: body,
              cache: 'no-cache',
              headers: headers,
              method: `${methodType}`,
              mode: 'no-cors',
          })
          .then(async response => {
            if ((response.status >= 200) && (response.status <= 299)) {
              return response.json().then(resolve);
            } else {
              return reject(response);
            }
          })
          .catch(e => {
              return reject(e);
          });
      });
    } catch (error) {
      return error;
    }
  },
  validateEmail: (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
};
